<script>
import { HorizontalBar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: HorizontalBar,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  mounted() {
    let options = {
      scales: {
        yAxes: [
          {
            gridLines: {
              drawTicks: false,
              drawBorder: true,
              display: true,
              drawOnChartArea: false,
            },
            ticks: {
              display: true,
            },
            display: true,
          },
        ],
        xAxes: [
          {
            gridLines: {
              drawTicks: false,
              drawBorder: false,
              display: true,
              drawOnChartArea: false,
            },
            ticks: {
              display: false,
            },
            display: true,
          },
        ],
      },
    };

    this.renderChart(this.chartData, options);
  },
};
</script>

<style></style>
